<template>
<div class="chapter">
<div class="inner_page">
<p class="head2"><a id="page_ix"><img alt="image" src="images/half1.jpg"/> <span class="small">ILLUSTRATIONS</span></a></p><a id="page_ix">
<p class="head3">M<span class="small">APS</span></p>
</a><p class="hang-a"><a id="page_ix"></a><a href="#/map#map1"><i>Map 1</i> <b>■</b> Justinian’s empire, ca. 565 <i>xvi</i></a></p>
<p class="hang-a"><a href="#/map#map2"><i>Map 2</i> <b>■</b> The Byzantine empire, ca. 1025 <i>xvii</i></a></p>
<p class="hang-a"><a href="#/map#map3"><i>Map 3</i> <b>■</b> Byzantium, ca. 1350 <i>xviii</i></a></p>
<p class="head3">F<span class="small">IGURES</span></p>
<p class="hang-a"><a href="#/ch01#ch1fig1"><i>Figure 1</i> <b>■</b> David Talbot Rice and Mark Ogilvie-Grant on their expedition to Mount Athos with Robert Byron <i>12</i></a></p>
<p class="hang-a"><a href="#/ch01#ch1fig2"><i>Figure 2</i> <b>■</b> Watercolor of Mount Athos by Edward Lear <i>19</i></a></p>
<p class="hang-a"><span href="#/ch02#ch2fig3" title="Link target outside of Sample"><i>Figure 3</i> <b>■</b> The cathedral of St. Sophia at Ohrid <i>37</i></span></p>
<p class="hang-a"><span href="#/ch02#ch2fig4" title="Link target outside of Sample"><i>Figure 4</i> <b>■</b> Ivory comb with jousting scene, tenth century <i>43</i></span></p>
<p class="hang-a"><span href="#/ch03#ch3fig5" title="Link target outside of Sample"><i>Figure 5</i> <b>■</b> The Parthenon <i>51</i></span></p>
<p class="hang-a"><a id="page_x"></a><span href="#/ch03#ch3fig6" title="Link target outside of Sample"><i>Figure 6</i> <b>■</b> The ruins of Mistra in the Peloponnese <i>61</i></span></p>
<p class="hang-a"><span href="#/ch04#ch4fig7" title="Link target outside of Sample"><i>Figure 7</i> <b>■</b> Icon of the Archangel Michael, tenth century <i>72</i></span></p>
<p class="hang-a"><span href="#/ch04#ch4fig8" title="Link target outside of Sample"><i>Figure 8</i> <b>■</b> Male dancers on the lid of a bone casket <i>81</i></span></p>
<p class="hang-a"><span href="#/ch05#ch5fig9" title="Link target outside of Sample"><i>Figure 9</i> <b>■</b> Icon <i>The Triumph of Orthodoxy</i>, ca. 1400 <i>91</i></span></p>
<p class="hang-a"><span href="#/ch05#ch5fig10" title="Link target outside of Sample"><i>Figure 10</i> <b>■</b> Chrysobull issued in 1342 by the emperor John V Palaeologus <i>104</i></span></p>
<p class="hang-a"><span href="#/ch05#ch5fig11" title="Link target outside of Sample"><i>Figure 11</i> <b>■</b> Emperor John VI Cantacuzenus (1347–54) surrounded by bishops at the council of 1351 <i>107</i></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// list.vue?2b8089e9